import Slider from "react-slick";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import rahulImg from "../assets/images/rahulImg.jpeg";
import deepeshImg from "../assets/images/deepeshImg.jpeg";
import vikasImg from "../assets/images/vikasImg.jpeg";
import harshadImg from "../assets/images/harshadImg.jpeg";


export default function Team() {
    const team = [
        {
            name: "RAHUL TIWARI",
            role: "Founding Member",
            img: rahulImg,
            desc: "Rahul Tiwari is a philanthropist, based in\n" +
                "Mumbai. He is an educationist and a\n" +
                "social worker. He is the secretary of Rahul\n" +
                "Group of Schools and Colleges,\n" +
                "comprising of 46 schools and colleges",
        },
        {
            name: "DEEPESH NIGAM",
            role: "Founding Member",
            img: deepeshImg,
            desc: "Deepesh is a MBA and Ex-Banker with 25+\n" +
                "Years of experience and had started his\n" +
                "own venture of AD's finance. With an\n" +
                "experience of more than a decade in\n" +
                "Finance and Debt.",
        },
        {
            name: "VIKAS SHARMA",
            role: "Founding Member",
            img: vikasImg,
            desc: "Industry expert with more than 25+ Years\n" +
                "of experience in Toys Industry in India.\n" +
                "Expert in imports and global supply chain\n" +
                "and vendor management. An Industrialist\n" +
                "with a vision to build in India for India.",
        },
        {
            name: "HARSHAD MESTRY",
            role: "Founding Member",
            img: harshadImg,
            desc: "Harshad Mestry is a MBA Finance with\n" +
                "more than 25+ years of experience in\n" +
                "the banking and finance industry. He has\n" +
                "a consistent track record & has deep\n" +
                "industry knowledge.",
        },
    ];


    const [selected, setSelected] = useState(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <section id="team" className="py-5 bg-light">
            <div className="container">
                <h2 className="section-title text-center mb-4">Meet Our Team</h2>

                <Slider {...settings}>
                    {team.map((t, i) => (
                        <div key={i} className="p-3">
                            <div className="team-card">
                                <img src={t.img} alt={t.name} className="team-img" />
                                <h5 className="team-name">{t.name}</h5>
                                <p className="team-role">{t.role}</p>
                                <p className="team-desc">{t.desc}</p>
                                <button
                                    className="btn-read-more"
                                    onClick={() => setSelected(t)}
                                >
                                    Read More
                                </button>
                            </div>
                        </div>
                    ))}
                </Slider>

                <Modal show={!!selected} onHide={() => setSelected(null)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{selected?.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <img
                            src={selected?.img}
                            alt={selected?.name}
                            className="rounded-circle mb-3"
                            style={{ width: "120px", height: "120px", objectFit: "cover" }}
                        />
                        <h6 className="text-muted">{selected?.role}</h6>
                        <p className="mt-3">{selected?.desc}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setSelected(null)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </section>
    );
}
